<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      @click:row="handleClick"
      :item-class="getItemClass"
    >
      <template v-slot:item.Duration="{ item }">
        <div :class="[getDurationClass(item), 'd-flex w-100 h-100']">
          <span class="my-auto px-1">{{ item.Duration }}</span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("DayName"),
          value: "EnterDayName",
        },
        {
          text: this.$t("date"),
          value: "BeginDate",
        },
        {
          text: this.$t("EntryTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("ExitTime"),
          value: "EndTime",
        },
        {
          text: this.$t("ExitDate"),
          value: "EndDate",
        },
        {
          text: this.$t("DurationTime"),
          value: "Duration",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
    getItemClass(item) {
      //console.log(item);
      if (item.DMP == "1") {
        return "bg-green";
      }
    },
    getDurationClass(item) {
      console.log(item);
      if (item.Duration == "۰۰:۰۰") {
        return "bg-red";
      }
    },
  },
};
</script>

<style>
</style>